'use client';

import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface MobileNavContextValue {
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}

const MobileNavContext = createContext<MobileNavContextValue>({
  hidden: false,
  setHidden: () => {},
});

export function MobileNavProvider({ children }: { children: ReactNode }) {
  const [hidden, setHiddenRaw] = useState(false);
  const setHidden = useCallback((v: boolean) => setHiddenRaw(v), []);

  return (
    <MobileNavContext.Provider value={{ hidden, setHidden }}>
      {children}
    </MobileNavContext.Provider>
  );
}

export function useMobileNav() {
  return useContext(MobileNavContext);
}
